
export enum CalculationHelpContentType {

    Default = 'default'

}